<content *ngIf="fieldData && fieldConfig">
  <a *ngIf="fieldData[fieldConfig.name]"
    [href]="getUrlView()" target="_blank">
    <img style="max-height: 80px;" [src]="getUrlPreview()" />
  </a>
  <!-- <i class="fas fa-file-download"></i> -->
</content>

